import React from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

const pulse = {
    animate: { opacity: [1, 0.6, 1], scale: [1, 1.06, 1] },
    transition: { duration: 2.5, repeat: Infinity, ease: "easeInOut" },
};

export function StrengthSignal({ strength }) {
    return (
        <div className="animate-fade-up" data-testid="strength-signal">
            <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-MUT font-mono mb-3">
                One strength the survey picked up:
            </div>
            <div className="rounded-2xl border border-klareet-T/50 bg-klareet-T/5 p-6">
                <p className="text-lg text-klareet-TEXT leading-relaxed">
                    {strength}
                </p>
            </div>

            <div className="mt-4 relative">
                <div
                    className="rounded-2xl border border-klareet-bor bg-klareet-card p-6 select-none"
                    style={{ filter: "blur(4px)" }}
                    aria-hidden
                >
                    <p className="text-lg text-klareet-TEXT leading-relaxed">
                        Your second strength is about how you handle setbacks
                        versus how you think others see you under pressure.
                        The gap between the two is the interesting part.
                    </p>
                </div>
                <div className="absolute inset-0 grid place-items-center">
                    <motion.button
                        type="button"
                        disabled
                        {...pulse}
                        className="flex items-center gap-2 px-4 py-2 rounded-full border border-klareet-bor bg-klareet-card text-klareet-MUT text-sm cursor-not-allowed"
                    >
                        <Lock size={14} />
                        Unlocks at launch
                    </motion.button>
                </div>
            </div>
        </div>
    );
}
